import { styled } from '@mui/material/styles';
import { Grid, Typography, Button } from '@mui/material';

export const SubscribeContainer = styled(Grid)(() => ({
    background: '#6639BF',
    borderRadius: '0.8em',
    padding: '1.25em',
}));

export const SubscribeTitle = styled(Typography)(() => ({
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '1.28em',
    color: '#fff',
    textTransform: 'capitalize',
    marginBottom: '0.5em',
}));

export const SubscribeIcon = styled('img')(() => ({
    width: '1.21em',
    height: '1.21em',
    objectFit: 'contain',
}));

export const MessageText = styled(Typography)(() => ({
    marginTop: '0.2em',
    fontFamily: 'Inter',
}));

export const SuccessText = styled(MessageText)(({ theme }) => ({
    color: theme.palette.success.main,
}));

export const SubscribeButton = styled(Button)(() => ({
    backgroundColor: '#2196F3',
    marginTop: '1.2em',
    color: '#fff',
}));

